/**
 * Created by OBL on 14/01/2016.
 */
define('adminKitsController',[
    'module',
    'underscore',
    'app',
    'adminKitsView',
    'bootbox',
    'kitCreateEditLayoutView',
    'settings',
    'entities/kits'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var AdminKitListController = {
        showKitList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'kit:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showKitAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                kitModel: App.request('kit:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('kit.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('kit:get-collection-url'),
                rowCountUrl: App.request('kit:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('kit.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('kit:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = AdminKitListController;
});
